// Export issue resolution as PDF or DOCX instruction document
import { FileText, FileDown } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu, DropdownMenuContent,
  DropdownMenuItem, DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { exportAsPDF, exportAsDOCX } from '@/lib/export-instructions'
import { useAuth } from '@/hooks/useAuth'

interface ExportInstructionsProps {
  issueTitle: string
  issueDescription: string
  d365Version: string
  d365Module: string
  category: string
  customerName?: string
  resolutionSummary: string
  steps?: { order: number; instruction: string; expectedResult?: string }[]
  disabled?: boolean
}

export function ExportInstructions({
  issueTitle, issueDescription, d365Version, d365Module,
  category, customerName, resolutionSummary, steps = [],
  disabled = false,
}: ExportInstructionsProps): JSX.Element {
  const { user } = useAuth()

  const data = {
    issueTitle, issueDescription, d365Version, d365Module,
    category, customerName, resolutionSummary, steps,
    exportedBy: user?.email || 'System',
    exportDate: new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' }),
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" disabled={disabled || !resolutionSummary}
          className="gap-1.5 border-kaycoo-teal-dark text-kaycoo-teal-dark hover:bg-kaycoo-teal-pale">
          <FileDown className="h-3.5 w-3.5" />
          Export Instructions
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        <DropdownMenuItem onClick={() => exportAsPDF(data)} className="cursor-pointer gap-2">
          <FileText className="h-4 w-4" />
          Export as PDF
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => exportAsDOCX(data)} className="cursor-pointer gap-2">
          <FileDown className="h-4 w-4" />
          Export as DOCX
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
